const dbDog = {
  mini: {
    1: 7,
    2: 13,
    3: 20,
    4: 26,
    5: 33,
    6: 40,
    7: 44,
    8: 48,
    9: 52,
    10: 56,
    11: 60,
    12: 64,
    13: 68,
    14: 72,
    15: 76,
    16: 80,
    17: 84,
    18: 88,
    19: 92,
    20: 96,
    21: 100,
    22: 104,
    23: 108,
    24: 112,
    25: 116,
  },
  little: {
    1: 7,
    2: 14,
    3: 21,
    4: 27,
    5: 34,
    6: 42,
    7: 47,
    8: 51,
    9: 56,
    10: 60,
    11: 65,
    12: 69,
    13: 74,
    14: 78,
    15: 83,
    16: 87,
    17: 92,
    18: 96,
    19: 101,
    20: 105,
    21: 109,
    22: 113,
    23: 117,
    24: 120,
    25: 124,
  },
  big: {
    1: 8,
    2: 16,
    3: 24,
    4: 31,
    5: 38,
    6: 45,
    7: 50,
    8: 55,
    9: 61,
    10: 66,
    11: 72,
    12: 77,
    13: 82,
    14: 88,
    15: 93,
    16: 99,
    17: 104,
    18: 109,
    19: 115,
    20: 120,
    21: 126,
    22: 130,
  },
  giant: {
    1: 9,
    2: 18,
    3: 26,
    4: 34,
    5: 41,
    6: 49,
    7: 56,
    8: 64,
    9: 71,
    10: 78,
    11: 86,
    12: 93,
    13: 101,
    14: 108,
    15: 115,
    16: 123,
    17: 131,
    18: 139,
  },
};

export default dbDog;
